import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl} from '@angular/forms';
import {RcFormControlAbstract} from '../rc-form-control-abstract/rc-form-control-abstract';

/**
 *
 * Rc switcher component - render a designed switcher
 *
 * @example
 * <lib-rc-switcher [control]="control" [elementId]="'mySwitcherID'">
 *     Please approve email notification
 * </lib-rc-switcher>
 */
@Component({
    selector: 'lib-rc-switcher',
    template: `<div class="rc-switcher-wrapper">
    <div class="rc-switcher-control-wrapper">
        <div class="rc-switcher-control">
            <input
                    class="switcher-checkbox"
                    type="checkbox"
                    id="{{elementId}}"
                    attr.aria-label="{{ariaLabel}}"
                    attr.aria-labeledby="{{ariaLabeledBy}}"
                    attr.aria-describedby="{{getAriaDescribedBy()}}"
                    [formControl]="control"
                    (change)="onChange($event)">
            <label class="switcher-indicator" [for]="elementId"></label>
        </div>
        <span *ngIf="labelText">{{labelText}}</span>
        <ng-container>
            <ng-content></ng-content>
        </ng-container>
    </div>
    <div id="{{errorElementId}}" class="invalid-feedback-message" role="alert" *ngIf="errorMsg"> {{ errorMsg }}</div>
</div>
`,
    styles: [`.rc-switcher-wrapper .rc-switcher-control{width:48px;height:30px;position:relative;display:inline-block}.rc-switcher-wrapper .rc-switcher-control input.switcher-checkbox{position:fixed;top:-1000px;left:-1000px}.rc-switcher-wrapper .rc-switcher-control input.switcher-checkbox:focus{outline:0!important}.rc-switcher-wrapper .rc-switcher-control input.switcher-checkbox:focus+label.switcher-indicator{box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.rc-switcher-wrapper .rc-switcher-control input.switcher-checkbox:active{outline:0!important}.rc-switcher-wrapper .rc-switcher-control input:checked+label{background-color:#266d9b}.rc-switcher-wrapper .rc-switcher-control input:hover+label{cursor:pointer}.rc-switcher-wrapper .rc-switcher-control input:checked+label:after{color:#266d9b;left:18px}.rc-switcher-wrapper .rc-switcher-control label.switcher-indicator{border:1.5px solid #d1d1d8;background-color:#fff;border-radius:15px;position:absolute;top:0;left:0;width:100%;height:100%;margin-bottom:0;transition:background-color 150ms ease-in-out}.rc-switcher-wrapper .rc-switcher-control label.switcher-indicator:after{content:'';transition:left 150ms ease-in-out;display:block;left:0;top:0;position:absolute;background:#fff;border-radius:50%;width:27px;height:27px;border:.7px solid rgba(0,0,0,.04);box-shadow:0 3px 8px 0 rgba(0,0,0,.15),0 1px 1px 0 rgba(0,0,0,.16),0 3px 1px 0 rgba(0,0,0,.1)}`]
})
export class RcSwitcherComponent extends RcFormControlAbstract implements OnInit {

    /**
     * Switcher label - will be displayed asside the switcher
     */
    @Input() labelText: string;

}
